import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = [];
const fetchProfileOptions = async () => {
  const url = qualifyUrl("/system/indices/index_sets/profiles/all");
  return fetch("GET", url).then(
    (profiles) => profiles.map(({ name, id }) => ({ value: id, label: name }))
  );
};
const useProfileOptions = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["indexSetFieldTypeProfileOptions"],
    queryFn: () => defaultOnError(
      fetchProfileOptions(),
      "Loading index field type profile options failed with status",
      "Could not load index field type profile options"
    ),
    placeholderData: keepPreviousData
  });
  return {
    options: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useProfileOptions;
